// extracted by mini-css-extract-plugin
export default {"cls1":"acTPoIN0gYIybGoZSqMg","cls2":"RpHmMSRh9R6FCtGOYoNa acTPoIN0gYIybGoZSqMg"};